import { LoadingOutlined } from '@ant-design/icons';
import { Spin, Typography } from 'antd';
import type { ReactNode } from 'react';
import { orgCardShadow } from './organisationsUi';
import { OrgPrimaryButton } from './OrgPrimaryButton';
import { OrganisationsPageLayout } from './OrganisationsPageLayout';

export function OrgPageLoading() {
  return (
    <OrganisationsPageLayout>
      <div style={{ textAlign: 'center', padding: 64 }}>
        <Spin indicator={<LoadingOutlined spin />} />
      </div>
    </OrganisationsPageLayout>
  );
}

export function OrgPageMessage({
  tone = 'danger',
  message,
  action,
}: {
  tone?: 'danger' | 'secondary';
  message: string;
  action?: ReactNode;
}) {
  return (
    <OrganisationsPageLayout>
      <section
        style={{
          background: '#fff',
          borderRadius: 8,
          boxShadow: orgCardShadow,
          padding: '32px 24px',
          textAlign: 'center',
        }}
      >
        <Typography.Text type={tone === 'danger' ? 'danger' : 'secondary'}>{message}</Typography.Text>
        {action ? <div style={{ marginTop: 16 }}>{action}</div> : null}
      </section>
    </OrganisationsPageLayout>
  );
}

export function OrgEmptyPanel({
  description,
  action,
}: {
  description: string;
  action?: ReactNode;
}) {
  return (
    <section
      style={{
        background: '#fff',
        borderRadius: 8,
        boxShadow: orgCardShadow,
        padding: '40px 24px',
        textAlign: 'center',
      }}
    >
      <Typography.Paragraph style={{ color: '#667085', marginBottom: action ? 16 : 0 }}>
        {description}
      </Typography.Paragraph>
      {action}
    </section>
  );
}

export function OrgReloadButton({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <OrgPrimaryButton onClick={onClick}>
      {label}
    </OrgPrimaryButton>
  );
}
